import React, { Component } from 'react'
import { connect } from 'react-redux'
import Axios from 'axios';
import "./NewConsultant.scss"
import SettingsWrapper from "../../../components/Settings/SettingsWrapper";
// Dialog Dependencies
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";

export class NewConsultant extends Component {
    state = {
        trend_ID: "",
        name: "",
        address: "",
        city: "",
        province: "",
        postal: "",
        phone: "",
        website: "",
        hours: "",
        warehouse: "",
        add_to_dev: false,
        add_to_ua: false,
        add_to_prod: false,
        dialog: null
    }

    add_new_consultant = async () => {
        let add_new_consultant_API_URL = this.props.APIUrl + "/consultant/add-new-consultant"
        let data = this.state
        let add_new_consultant_API_response = await Axios.post(add_new_consultant_API_URL, data)

        console.log("api response ", add_new_consultant_API_response)
        // I have to create validation and a success message. Since there are so many input fields this gona be a stupid time waster
        if (add_new_consultant_API_response.data.message) {
            let dialog_content = <Dialog open={true} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title set-price-dialog-header">
                    Success{" "}
                </DialogTitle>
                <DialogContent style={{ width: "75rem" }}>
                    <p>{add_new_consultant_API_response.data.message}</p>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => this.setState({ dialog: null })} color="primary">
                        Okay
					</Button>


                </DialogActions>
            </Dialog>

            this.setState({ dialog: dialog_content })
        } else {
            let dialog_content =
                <Dialog open={true} aria-labelledby="form-dialog-title">
                    <DialogTitle id="form-dialog-title set-price-dialog-header">
                        Error{" "}
                    </DialogTitle>
                    <DialogContent style={{ width: "75rem" }}>
                        <p>{add_new_consultant_API_response.data.error.errors[0].message}</p>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => this.setState({ dialog: null })} color="primary">
                            Okay
					</Button>
                    </DialogActions>
                </Dialog>

            this.setState({ dialog: dialog_content })
        }

    }

    render() {
        let main = (
            <>
                {this.state.dialog}
                <div class="card user-profile-card">
                    <div class="card-body">
                        <div class="form-group project-copy-form-group">
                            <label>M3 ID</label>
                            <input
                                type="text"
                                class="form-control  project-copy-input"
                                onChange={event => this.setState({ trend_ID: event.target.value })}
                            />
                        </div>
                        <div class="form-group project-copy-form-group">
                            <label>Name</label>
                            <input
                                type="text"
                                class="form-control  project-copy-input"
                                onChange={event => this.setState({ name: event.target.value })}

                            />
                        </div>
                        <div class="form-group project-copy-form-group">

                            <label>Address</label>
                            <input
                                type="text"
                                class="form-control project-copy-input"
                                onChange={event => this.setState({ address: event.target.value })}

                            />
                        </div>
                        <div class="form-group project-copy-form-group">

                            <label>City</label>
                            <input
                                type="text"
                                class="form-control  project-copy-input"
                                onChange={event => this.setState({ city: event.target.value })}

                            />
                        </div>
                        <div class="form-group project-copy-form-group">

                            <label>Province *</label>
                            <input
                                type="text"
                                class="form-control  project-copy-input"
                                onChange={event => this.setState({ province: event.target.value })}

                            />
                        </div>
                        <div class="form-group project-copy-form-group">

                            <label>Postal Code *</label>
                            <input
                                type="text"
                                class="form-control  project-copy-input"
                                onChange={event => this.setState({ postal: event.target.value })}

                            />
                        </div>
                        <div class="form-group project-copy-form-group">

                            <label>Phone</label>
                            <input
                                type="text"
                                class="form-control  project-copy-input"
                                onChange={event => this.setState({ phone: event.target.value })}

                            />
                        </div>
                        <div class="form-group project-copy-form-group">

                            <label>Website</label>
                            <input
                                type="text"
                                class="form-control  project-copy-input"
                                onChange={event => this.setState({ website: event.target.value })}

                            />
                        </div>
                        <div class="form-group project-copy-form-group">

                            <label>Hours</label>
                            <input
                                type="text"
                                class="form-control  project-copy-input"
                                onChange={event => this.setState({ hours: event.target.value })}

                            />
                        </div>
                        <div class="form-group project-copy-form-group">

                            <label>Warehouse</label>
                            <input
                                type="text"
                                class="form-control  project-copy-input"
                                onChange={event => this.setState({ warehouse: event.target.value })}

                            />
                        </div>
                    </div>
                </div>
                <div class="card user-profile-card">
                    <div class="card-body">
                        <h4>Add To</h4>
                        <label>Dev</label><input type="checkbox" class="new-consultant-add-to-buttons" onChange={() => this.setState({ add_to_dev: !this.state.add_to_dev })} />
                        <label>UA</label><input type="checkbox" class="new-consultant-add-to-buttons" onChange={() => this.setState({ add_to_dev: !this.state.add_to_ua })} />
                        <label>Production</label><input type="checkbox" class="new-consultant-add-to-buttons" onChange={() => this.setState({ add_to_dev: !this.state.add_to_prod })} />

                    </div>
                    <button style={{ height: "3em" }} onClick={this.add_new_consultant} type="button" class="btn btn-primary">
                            Add Consultant
                    </button>
                </div>
            </>
        );

        return (
			<SettingsWrapper header="Add Consultant" main={main} />
		);
    }
}

const mapStateToProps = (state) => ({
    APIUrl: state.APIUrl
})

const mapDispatchToProps = {

}

export default connect(mapStateToProps, mapDispatchToProps)(NewConsultant)
